// Typelizer digest 35c2a1acbccd0b8196f5c3450840892e
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** DELETE /api/v1/session */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/api/v1/session', {}, options),
    method: 'delete',
  }),

  /** POST /api/v1/session */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/api/v1/session', {}, options),
    method: 'post',
  }),
}
